<div class="row loading-row" style="margin: auto">
    <div class="col-12 text-center">
        <img src="../../../assets/img/loading_spin.gif" width="15%">
    </div>
</div>